import { onTracking, ExtTrackingNotice } from "@hyext-inner/ext-web-comp";
import { report } from "../../util/tracking";
import HyExtAdapter from "../adapters/HyExtAdapter";

export enum Status {
  SUCC = 1,
  FAIL = 0,
}

export default class HyExtTrackingInLiveRoom {
  adapter: HyExtAdapter
  constructor(adapter: HyExtAdapter) {
    this.adapter = adapter

    onTracking({
      key: 'fetch_list_succ',
      handler: notice => this.hyext_endpoint_ext_list_request(notice, Status.SUCC),
    })
    onTracking({
      key: 'fetch_list_fail',
      handler: notice => this.hyext_endpoint_ext_list_request(notice, Status.FAIL),
    })
    onTracking({
      key: 'show_entrance_succ',
      handler: notice => this.hyext_endpoint_ext_entrance_show(notice, Status.SUCC),
    })
    onTracking({
      key: 'show_entrance_fail',
      handler: notice => this.hyext_endpoint_ext_entrance_show(notice, Status.FAIL),
    })
    onTracking({
      key: 'load_supframe_fail',
      handler: notice => this.hyext_endpoint_ext_load(notice, Status.FAIL),
    })
    onTracking({
      key: 'load_busiframe_fail',
      handler: notice => this.hyext_endpoint_ext_load(notice, Status.FAIL),
    })
    onTracking({
      key: 'load_busiframe_succ',
      handler: notice => this.hyext_endpoint_ext_load(notice, Status.SUCC),
    })
  }
  async getDim(notice: ExtTrackingNotice, status: Status) {
    const userId = await this.adapter.getUserId()
    const uid = String(userId.lUid)
    const pid = String(this.adapter.getStreamerUid())
    const ext_uuid = notice.extUuid || ''
    const ext_type = notice.extType || ''
    const ua = userId.sHuYaUA
    const session_id = notice.session_id
    const gid = String(this.adapter.getGameId())
    const environment = process.env.BUILD_MODE === 'test' ? 'test' : 'prod'
    return {
      uid,
      pid,
      ext_uuid,
      ext_type,
      ua,
      status: String(status),
      session_id,
      gid,
      environment,
    }
  }
  async hyext_endpoint_ext_list_request(notice: ExtTrackingNotice, status: Status) {
    const eid = 'hyext.endpoint.ext.list.request'
    const dim = await this.getDim(notice, status)
    const field = notice.globalData
    report(eid, dim, field)
  }
  async hyext_endpoint_ext_entrance_show(notice: ExtTrackingNotice, status: Status) {
    const eid = 'hyext.endpoint.ext.entrance.show'
    const dim = await this.getDim(notice, status)
    const field = notice.extData
    report(eid, dim, field)
  }
  async hyext_endpoint_ext_load(notice: ExtTrackingNotice, status: Status) {
    const eid = 'hyext.endpoint.ext.load'
    const dim = await this.getDim(notice, status)
    const field = notice.extData
    report(eid, dim, field)
  }
}
